import { useEffect, useState } from 'react';
import { useApi, configApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { Approver, listApprovers } from '../api';

export function OciApproverPickerComponent({
  onChange,
  rawErrors,
  formData,
}: any) {
  const configApi = useApi(configApiRef);
  const fetchApi = useApi(fetchApiRef);
  const backendUrl = configApi.getString('backend.baseUrl');
  const [approvers, setApprovers] = useState<Approver[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    listApprovers(fetchApi, backendUrl)
      .then(list => {
        setApprovers(list);
        if (list.length > 0 && !formData) {
          onChange(list[0].email);
        }
      })
      .catch(() => setError('Failed to load approvers'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <CircularProgress size={20} />;

  return (
    <FormControl fullWidth error={!!rawErrors?.length || !!error}>
      <InputLabel>Assign Approver</InputLabel>
      <Select
        value={formData ?? ''}
        onChange={e => onChange(e.target.value as string)}
      >
        {approvers.length === 0 && (
          <MenuItem value="" disabled>
            No approvers available
          </MenuItem>
        )}
        {approvers.map(a => (
          <MenuItem key={a.email} value={a.email}>
            {a.displayName} — {a.email}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}

export const OciApproverPickerField = createFormField({
  name: 'OciApproverPicker',
  component: OciApproverPickerComponent,
});
